"use strict";

exports.__esModule = true;
exports.Logger = void 0;
/*
 * COPYRIGHT 2020-2021 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */
/*
 *  This class is intended to be replaced by third party code if required.  The console suite of functions is not available
 *  on all platforms.
 */
var Logger = /*#__PURE__*/function () {
  function Logger() {}
  Logger.debug = function debug(string) {
    console.log(string);
  };
  Logger.error = function error(string) {
    console.error(string);
  };
  Logger.info = function info(string) {
    console.info(string);
  };
  Logger.warn = function warn(string) {
    console.warn(string);
  };
  return Logger;
}();
exports.Logger = Logger;